module.exports = __webpack_public_path__ + "static/img/slider-img01.819adf6.png";